import React from "react";
import { Card, CardContent, Avatar, Typography, Stack } from "@mui/material";

const DashboardCard = ({ title, value, icon, color = "primary.main" }) => {
  return (
    <Card
      elevation={0}
      sx={{
        height: 68,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        transition: "0.2s",

        "&:hover": {
          boxShadow: 2,
          transform: "translateY(-1px)",
        },
      }}
    >
      <CardContent
        sx={{
          width: "100%",
          p: 1,
          "&:last-child": {
            pb: 1,
          },
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack spacing={0}>
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 600,
                color: "text.secondary",
                textTransform: "uppercase",
                lineHeight: 1.1,
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontSize: 24,
                fontWeight: 700,
                lineHeight: 1,
              }}
            >
              {value}
            </Typography>
          </Stack>

          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: color,

              "& svg": {
                fontSize: 18,
              },
            }}
          >
            {icon}
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
};
export default DashboardCard;
